import { oz } from '@weft/utils';
import { HomePagePredictedMonthlyRevenueSchema } from './home-page-predicted-monthly-revenue-schema';

export const HomePageYtdRevenueSchema = oz.object({
  monthlyRevenue: oz.record(oz.number().nonnegative()),
  predictedMonthlyRevenue: oz.array(HomePagePredictedMonthlyRevenueSchema),
}).openapi('HomePageYtdRevenue');

export type HomePageYtdRevenue = oz.infer<typeof HomePageYtdRevenueSchema>;